export { default } from './PasswordResetCover';
